export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-2.e1fb1dbd.png";